module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-bottom-stone-path-remnants.430fe50b.png";